import { render } from "./AnnualWorkScheduleEdit.vue?vue&type=template&id=67965f5e&scoped=true"
import script from "./AnnualWorkScheduleEdit.vue?vue&type=script&lang=js"
export * from "./AnnualWorkScheduleEdit.vue?vue&type=script&lang=js"

import "./AnnualWorkScheduleEdit.vue?vue&type=style&index=0&id=67965f5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67965f5e"]])

export default __exports__